import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _Getters;

import * as types from "@/store/constants/types";
var Getters = (_Getters = {}, _defineProperty(_Getters, types.GETTER_DEVICE_ID, function (state, payLoad) {
  return state.deviceId;
}), _defineProperty(_Getters, types.GETTER_SERVICE_LIST, function (state) {
  return state.serviceList;
}), _defineProperty(_Getters, types.GETTER_USER_MSG, function (state) {
  return state.userMsg;
}), _defineProperty(_Getters, types.GETTER_RATE_US_STATUS, function (state) {
  return state.ratedUs;
}), _defineProperty(_Getters, types.GETTER_VIP_CLOSE_COUNT, function (state) {
  return state.vipCloseCount;
}), _Getters);
export default Getters;